<!--
 * @Author: natsu
 * @Date: 2020-06-04 08:47:44
 * @LastEditors: natsu
 * @LastEditTime: 2020-06-08 15:29:33
 * @Description: file content
-->
<template>
  <div class="wrapper">
    <header class="bg">
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/javascript.png" /></div>
      <p>micro 工具</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = "https://uedcdn.zto.com/static/micro/";
export default {
  name: "index",
  data() {
    return {
      fileList: [
        {
          label: "release",
          linkList: [
            ur + "micro-help-iframe.js",
            ur + "micro-help.js",
            ur + "pre-release/micro-help-iframe.js",
            ur + "pre-release/micro-help.js"
          ]
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/view/ListMicro.vue